exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".floating-window[data-v-d90a7e9e]{z-index:999;position:absolute;top:400px;right:12px}", ""]);

// exports
